import React, { createContext, Dispatch, useEffect } from 'react';
import { Route, BrowserRouter as Router, Redirect, useParams } from 'react-router-dom';
import { AutomaticComponent } from './components/megawidget/megawidget-specialty/automatic-component';
import { MegawidgetSComponent } from './components/megawidget/megawidget-specialty/megawidget-s.component/megawidget-s.component';
import { MegawidgetMComponent } from './components/megawidget/megawidget-specialty/megawidget-m.component/megawidget-m.component';
import { MegawidgetLComponent } from './components/megawidget/megawidget-specialty/megawidget-l.component/megawidget-l.component';
import { MegawidgetXLComponent } from './components/megawidget/megawidget-specialty/megawidget-xl.component/megawidget-xl.component';
import { commonReducer, initialState, IWidgetState, } from './components/megawidget/megawidget-specialty/common/common-reducer';
import { IAction } from './components/megawidget/megawidget-specialty/common/common-actions';
import MegawidgetCommonFacade from './facades/megawidget-specialty/megawidget-common.facade';
import WidgetSizeHelper from './helpers/widget-size-helper';
import getWindowSize from './helpers/window-resize';
import './components/megawidget/megawidget-specialty/common/common.css';
import './components/megawidget/megawidget-specialty/megawidget-s.component/megawidget-s.css';
import './components/megawidget/megawidget-specialty/megawidget-m.component/megawidget-m.css';
import './components/megawidget/megawidget-specialty/megawidget-l.component/megawidget-l.css';
import './components/megawidget/megawidget-specialty/megawidget-xl.component/megawidget-xl.css';

export const CommonContext = createContext<{ state: IWidgetState; dispatch: Dispatch<IAction> }>({ state: initialState, dispatch: () => undefined });

const App: React.FC = () => {
  const [state, dispatch] = React.useReducer(commonReducer, initialState);
  const [width, height] = getWindowSize();
  const commonFacade = new MegawidgetCommonFacade(state, dispatch);
  
  const url = window.location.href;
  const vendorCode = url.slice(url.indexOf('vendor:') + 'vendor:'.length, url.indexOf('doctorCode:') - 1);
  let doctorCode = '';
  let color = '';
  if (url.indexOf('color') > 0) {
     doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length, url.indexOf('color:') - 1);
     color = url.slice(url.indexOf('color:') + 'color:'.length);
  } else {
    doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length);  
  }

  // initial variables
  useEffect(() => {
    //commonFacade.getDoctors();
    var linkElement = document.createElement('a');
    linkElement.id = 'link';
    window.document.body.appendChild(linkElement);
    commonFacade.getAvailableSlots(doctorCode, vendorCode);
    commonFacade.setInitialSize();
    commonFacade.setInitialVendor();
  }, []);

  // on width screen
  useEffect(() => {
    commonFacade.setNewSize(width);
  }, [width])

  // on request
  useEffect(() => {
    if (state.request.url && state.request.selectedRegion && state.request.selectedSpecialisation) {
      const makeRequest = async () => {
        commonFacade.setIsLoading(true);
        commonFacade.setResult(await commonFacade.getAppointments(state.request.url));
        commonFacade.setIsLoading(false);
      }
      makeRequest();
    }
  }, [state.request])

  return (
    <div className="medicoverMegawidgetMainClass">
      <CommonContext.Provider value={{ state, dispatch }}>
        <Router>
          <Route exact path={WidgetSizeHelper.S.routeWithVendor} component={MegawidgetSComponent} />
          <Route exact path={WidgetSizeHelper.M.routeWithVendor} component={MegawidgetMComponent} />
          <Route exact path={WidgetSizeHelper.M2.routeWithVendor} component={MegawidgetMComponent} />
          <Route exact path={WidgetSizeHelper.L.routeWithVendor} component={MegawidgetLComponent} />
          <Route exact path={WidgetSizeHelper.XL.routeWithVendor} component={MegawidgetXLComponent} />
          <Route exact path={WidgetSizeHelper.AUTOMATIC.routeWithVendor} component={AutomaticComponent} />

          <Route exact path='/' render={() => <Redirect to="/M/vendor:medicover/doctorCode:2137" />} />
          <Route exact path={WidgetSizeHelper.S.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.S.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
          <Route exact path={WidgetSizeHelper.M.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.M.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
          <Route exact path={WidgetSizeHelper.M2.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.M.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
          <Route exact path={WidgetSizeHelper.L.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.L.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
          <Route exact path={WidgetSizeHelper.XL.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.XL.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
          <Route exact path={WidgetSizeHelper.AUTOMATIC.routeWithoutVendor} render={() => <Redirect to={`${WidgetSizeHelper.AUTOMATIC.routeWithoutVendor}/${WidgetSizeHelper.defaultVendor}`} />} />
        </Router>
      </CommonContext.Provider>
    </div>
  )
}

export default App;


